/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { LecturerEvaluationUpdateRequestEvaluationAnyOf } from './lecturerEvaluationUpdateRequestEvaluationAnyOf';

export type LecturerEvaluationUpdateRequestEvaluation = LecturerEvaluationUpdateRequestEvaluationAnyOf | null;
